<template>
  <div class="custom-detail-row flex flex-row gap-2 w-full">
    <div v-if="!autosave" class="flex flex-col gap-4 pt-2 h-full">
      <template v-if="!inEditDetail">
        <base-button-icon name="editpencil" size="md" icon-size="sm" @click.stop="editDetail" />
        <!-- <div class="w-10/5 h-10/5 invisible">Div for pad editpencil button</div> -->
      </template>
      <template v-else>
        <base-button-icon name="save" size="md" icon-size="sm" @click.stop="checkLine(scope)" />
        <base-button-icon name="cross" size="md" icon-size="sm" @click.stop="cancel" />
      </template>
    </div>
    <div class="flex flex-col gap-2 w-full">
      <div class="w-full flex flex-col gap-2">
        <div class="flex flex-row gap-2 w-full">
          <div class="w-full">
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="require" />{{ $t('invoices.invoices_issuing.step4.cantidad') }}</label>
              <el-input clearable class="w-full" v-model="scope.cantidad" type="number" size="mini" :disabled="!inEditDetail" @input="controlCantidad(scope, $event)" />
            </div>
            <div class="mt-2">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="require" />{{ $t('invoices.invoices_issuing.precio_unitario') }}</label>
              <el-input clearable class="w-full" v-model="scope.UnitPriceWithoutTax" type="number" size="mini" :disabled="!inEditDetail" @input="controlPrecioUnitario(scope, $event)" />
            </div>
            <!-- <base-ro-input class="mt-2" mini :label="$t('app.subtotal')" :data="formatNumberWithDefault(scope.subtotal)" /> -->
          </div>
          <div class="w-full">
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.invoices_issuing.descuento_long') }}</label>
              <el-input clearable class="w-full" v-model="scope.descuentos[0].descuento" type="number" size="mini" :disabled="!inEditDetail" @input="controlDescuento(scope, $event)" />
            </div>
            <div class="mt-2">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.invoices_issuing.discount_cuota') }}</label>
              <el-input clearable class="w-full" v-model="scope.descuentos[0].cuota" type="number" size="mini" :disabled="!inEditDetail" @input="controlCuota(scope, $event)" />
            </div>
          </div>
          <div class="flex flex-col gap-2 w-full">
            <div class="w-full">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="require"/>{{ $t('impuestos.entity_name') }}</label>
              <!-- Quitar [0], cambiar [e] por e y agregar atributo múltiple para admitir varios impuestos -->
              <base-el-select clearable class="w-full" v-model="scope.Taxes[0]" size="mini" value-key="idImpuesto" :option-value="taxValue" :options="hasOperationType ? zeroTax : scope.Impuestos" :disabled="!inEditDetail || hasOperationType" @input="controlImpuestos(scope, [$event])" />
            </div>
            <div class="w-full mt-2">
              <base-ro-input class="flex-1" mini :label="$t('invoices.invoices_issuing.tax_cuota')" :data="formatNumberWithDefault(scope.Taxes[0].cuota)" />
            </div>
          </div>
          <div v-if="hasEquivalenceSurcharge" class="flex flex-col gap-2 w-full">
            <base-ro-input class="flex-1" mini :label="$t('impuestos.equivalence_surcharge_type')" :data="formatNumberWithDefault(scope.Taxes[0].EquivalenceSurcharge)" />
            <base-ro-input class="flex-1" mini :label="$t('impuestos.equivalence_surcharge_quota')" :data="formatNumberWithDefault(scope.cuotaRecargo)" />
          </div>
          <div class="flex flex-col gap-2 w-full">
            <base-ro-input class="flex-1" mini :label="$t('app.total_no_tax')" :data="formatNumberWithDefault(scope.total)" />
            <base-ro-input class="flex-1" mini :label="$t('app.total')" :data="formatNumberWithDefault(scope.totalConImpuesto)" />
          </div>
        </div>
        <div class="w-full">
          <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.invoices_issuing.observaciones') }}</label>
          <el-input clearable class="w-full" v-model="scope.additionalLineItemInformation" type="textarea" :rows="2" resize="none" :maxlength="additionalLineItemInformationMaxLength" show-word-limit size="mini" :disabled="!inEditDetail" @input="save(true)" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { i18n } from '@/i18n'

import getNestedValue from '@/services/functions/getNestedValue'
import setNestedValue from '@/services/functions/setNestedValue'
import lineCalcs from '@/services/functions/lines/lineCalcs'

export default {
  props: {
    scope: Object,
    inEdit: Boolean,
    inEditDetail: Boolean,
    require: {
      type: Boolean,
      default: false
    },
    autosave: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      additionalLineItemInformationMaxLength: '2500',
    }
  },
  computed: {
    hasOperationType: function () {
      return this.operationType === 1 || this.operationType === 2 || this.operationType === 3
    },
    operationType: function () {
      return this.$store.getters['invoicesIssuing/2/form']?.tipoImpuestoFactura
    },
    hasEquivalenceSurcharge: function () {
      return this.$store.getters['invoicesIssuing/2/form']?.applyEquivalenceSurcharge
    },
    tiposOperacion: function () {
      return this.$store.getters['config/TIPOS_OPERACION_TRIBUTACION'].find(x => x.id === this.operationType)?.name
    },
    zeroTax: function () {
      return {
        Name: this.tiposOperacion || this.operationType,
        TaxType: '01',
        TaxRate: 0,
        TaxCategory: 0,
        idImpuesto: -1
      }
    }
  },
  watch: {
    'scope.UnitPriceWithoutTax': function (value, oldValue) {
      if (value !== oldValue) {
        this.recalculate()
      }
    }
  },
  created: function () {
    if (this.scope.subtotal !== this.scope.UnitPriceWithoutTax * this.scope.cantidad) {
      this.recalculate()
    }
  },
  methods: {
    recalculate: function () {
      lineCalcs.recalculate(this.scope, this.hasEquivalenceSurcharge, this.operationType)
      this.save(true)
    },
    controlPrecioUnitario: function (dataItem, UnitPriceWithoutTax = dataItem.UnitPriceWithoutTax) {
      if (this.isFalsy(UnitPriceWithoutTax)) {
        this.doFeedback(i18n.t('invoices.invoices_issuing.step4.need_unit_price'))
      }
      this.controlCantidad(dataItem)
    },
    controlCantidad: function (dataItem, cantidad = dataItem.cantidad) {
      if (this.isFalsy(cantidad)) {
        this.doFeedback(i18n.t('invoices.invoices_issuing.step4.need_cantidad'))
      } else if (cantidad <= 0) {
        cantidad = ''
        this.doFeedback(i18n.t('invoices.invoices_issuing.step4.valid_cantidad'))
      }
      // Se quita esta validación para permitir decimales en las UNIDADES,
      // a petición de cliente/arriba, porque "nadie usa las otras medidas"
      // else if (cantidad.includes('.') && dataItem.UnitOfMeasure.includes('01')) {
      //   cantidad = ''
      //   this.doFeedback(i18n.t('invoices.invoices_issuing.step4.valid_product'))
      // }
      this.calculateSubTotal(dataItem, cantidad)
      const incluyeDescuento = dataItem.descuentos[0].incluyeDescuento
      const descuento = dataItem.descuentos[0].descuento
      const cuota = dataItem.descuentos[0].cuota
      if (incluyeDescuento && this.isNotFalsy(descuento)) {
        this.controlDescuento(dataItem, descuento)
      } else if (!incluyeDescuento && this.isNotFalsy(cuota)) {
        this.controlCuota(dataItem, cuota)
      } else {
        this.calculateTotal(dataItem)
        this.calculateCuotaRecargo(dataItem, dataItem.Taxes[0].EquivalenceSurcharge)
        this.calculateTotalConImpuesto(dataItem) 
      }
    },
    controlCuota: function (dataItem, cuota = dataItem.cuota) {
      var valid = true
      if (cuota !== '' && cuota !== 0 && dataItem.subtotal !== 0 && ((cuota < 0 && dataItem.subtotal > 0) || (cuota > 0 && dataItem.subtotal < 0))) {
        this.doFeedback(i18n.t('invoices.invoices_issuing.step4.valid_cuota', { max: dataItem.subtotal }))
        cuota = ''
        valid = false
      }
      const descuento = cuota !== '' && dataItem.subtotal !== '' ? cuota * 100 / dataItem.subtotal : 0
      setNestedValue('descuento', dataItem.descuentos[0], descuento, true)
      setNestedValue('incluyeDescuento', dataItem.descuentos[0], (cuota !== '' ? false : (valid ? '' : null)), true)
      this.calculateTotal(dataItem)
      this.calculateCuotaRecargo(dataItem, dataItem.Taxes[0].EquivalenceSurcharge)
      this.calculateTotalConImpuesto(dataItem)
    },
    controlDescuento: function (dataItem, descuento = dataItem.descuento) {
      var valid = true
      if (descuento !== '' && (descuento < 0 || descuento > 100)) {
        this.doFeedback(i18n.t('invoices.invoices_issuing.step4.valid_discount'))
        descuento = ''
        valid = false
      }
      const cuota = descuento !== '' && dataItem.subtotal !== '' ? dataItem.subtotal * descuento / 100 : 0
      setNestedValue('cuota', dataItem.descuentos[0], cuota, true)
      setNestedValue('incluyeDescuento', dataItem.descuentos[0], (descuento !== '' ? true : (valid ? '' : null)), true)
      this.calculateTotal(dataItem)
      this.calculateCuotaRecargo(dataItem, dataItem.Taxes[0].EquivalenceSurcharge)
      this.calculateTotalConImpuesto(dataItem)
    },
    controlImpuestos: function (dataItem, Taxes = dataItem.Taxes || []) {
      if (this.isFalsy(Taxes) && getNestedValue(this.selectedField, dataItem) && this.isNotFalsy(dataItem.cantidad)) {
        this.calculateCuotaRecargo(dataItem, 0)
        this.doFeedback(i18n.t('feedback.error.obligatory_field_error', { field: i18n.t('impuestos.entity_name').toLowerCase() }))
      } else if (!this.isFalsy(Taxes) && Taxes[0].EquivalenceSurcharge) {
        this.calculateTotal(dataItem)
        this.calculateCuotaRecargo(dataItem, Taxes[0].EquivalenceSurcharge)
      } else if (Taxes[0].EquivalenceSurcharge === 0 || Taxes[0].EquivalenceSurcharge === '0') {
        this.calculateCuotaRecargo(dataItem, 0)
      }
      if (Taxes.some(x => x.TaxRate === 0)) {
        this.doFeedback(i18n.t('invoices.invoices_issuing.step4.warning_zero_tax_rate'), 'warning', 6000)
      }
      this.calculateTotalConImpuesto(dataItem)
    },
    calculateSubTotal: function (dataItem, cantidad = dataItem.cantidad) {
      lineCalcs.calculateSubTotal(dataItem, cantidad)
    },
    calculateTotal: function (dataItem) {
      lineCalcs.calculateTotal(dataItem)
    },
    calculateCuotaRecargo: function (dataItem, recargo) {
      lineCalcs.calculateCuotaRecargo(dataItem, recargo, this.hasEquivalenceSurcharge)
    },
    calculateTotalConImpuesto: function (dataItem) {
      lineCalcs.calculateTotalConImpuesto(dataItem, this.hasEquivalenceSurcharge, this.hasOperationType)
      this.save(true)
    },
    formatNumberWithDefault: function (number, format = 'currency_8', vdefault = ' - ') {
      if (this.isFalsy(number)) {
        return vdefault
      }
      return i18n.n(number, format)
    },
    taxValue: function (option) {
      return option
    },
    isNotFalsy: function (value) {
      if (Array.isArray(value)) {
        return value.length && value.every(x => this.isNotFalsy(x))
      }
      return ![undefined, null, false, ''].includes(value)
    },
    isFalsy: function (value) {
      return !this.isNotFalsy(value)
    },
    checkLine: function (scope) {
      if (scope.totalConImpuesto === undefined || scope.totalConImpuesto === null || scope.totalConImpuesto === '') {
        this.doFeedback(i18n.t('invoices.invoices_issuing.step4.valid_total'))
      } else {
        this.save()
      }
    },
    save: function (keepEdit = false) {
      if (this.autosave || !keepEdit) {
        this.$emit('save', !!keepEdit)
      }
    },
    cancel: function () {
      this.$emit('edit-detail', false)
      this.$emit('edit', false)
      this.$emit('cancel', false)
    },
    editDetail: function () {
      this.$emit('edit-detail', true)
      this.$emit('edit', false)
    }
  },
}
</script>
  
